import { createEditorState } from 'medium-draft';
import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, intlShape, injectIntl } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'lodash';
import classNames from 'classnames';
import moment from 'moment';

import Modal from '@material-ui/core/Modal';
import CircularProgress from '@material-ui/core/CircularProgress';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';

import withWidth, { isWidthUp } from '@material-ui/core/withWidth';
import CloseIcon from '@material-ui/icons/Close';
import DoneIcon from '@material-ui/icons/Done';
import LoadingBar from 'react-redux-loading-bar';
import NextIcon from '@material-ui/icons/NavigateNext';
import { stateToHTML } from 'draft-js-export-html';
import { Interweave } from 'interweave';
import Link from '../../../components/Link/Link';
import {
  isTeacher,
  isAdmin,
  buildQuery,
  hasMedicalLicense,
  convertBreakLines,
  isTrial,
} from '../../../helpers';
import isMobileUserAgent from '../../../helpers/checkMobileUserAgent';
import Intercom from '../../../widgets/Intercom';
import CongratulationsModal from '../../lessonDetails/CongratulationsModal/CongratulationsModal';
import ConfirmUnlockDialog from '../../tasks/examTaskResults/ConfirmUnlockDialog';

import NavBar from '../NavBar';
import entityStyleFn from '../studentViewQuiz/entityStyleFn';
import s from './QuizResult.scss';
import * as viewQuizActions from '../../../actions/viewQuiz';
import * as editTaskActions from '../../../actions/editGroupTask';
import * as quizResultsActions from '../../../actions/quizResult';
import SectionItemNavigationMenu from '../../../components/SectionItemNavigationMenu/SectionItemNavigationMenu';
import messages from './quizResultMessages';
import SkholeIcon38 from '../../../components/statelessComponents/Icons/SkholeIcon38';
import SkholeIcon38Correct from '../../../components/statelessComponents/Icons/SkholeIcon38Correct';
import SkholeStudentCorrect from '../../../components/statelessComponents/Icons/SkholeStudentCorrect';
import SkholeStudentIncorrect from '../../../components/statelessComponents/Icons/SkholeStudentIncorrect';
import SkholeIconIncorrect from '../../../components/statelessComponents/Icons/SkholeIconIncorrect';
import {
  replaceDecimalsSeparatorToComma,
  substituteVariablesInQuestion,
} from '../../../helpers/mathQuestions';

@withWidth()
@injectIntl
@withStyles(s)
@connect(
  state => ({
    auth: state.auth,
    loadingQuizResult: state.quizResult.loading,
    quizResult: state.quizResult.quizResult,
    course: state.courseDetails.course,
    quiz: state.viewQuiz.quiz,
    task: state.editTask.task,
    lang: state.intl.locale,
  }),
  dispatch =>
    bindActionCreators(
      {
        startQuiz: viewQuizActions.startQuiz,
        getTaskWithCertificate: editTaskActions.getTaskWithCertificate,
        getResult: quizResultsActions.getResult,
      },
      dispatch,
    ),
)
export default class QuizResult extends React.Component {
  static propTypes = {
    loadingQuizResult: PropTypes.bool.isRequired,
    quizResult: PropTypes.object.isRequired, // eslint-disable-line
    quiz: PropTypes.object.isRequired, // eslint-disable-line
    auth: PropTypes.object.isRequired, // eslint-disable-line
    course: PropTypes.object.isRequired, // eslint-disable-line
    query: PropTypes.object, // eslint-disable-line
    intl: intlShape.isRequired,
    getTaskWithCertificate: PropTypes.func.isRequired,
    lang: PropTypes.string.isRequired,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    task: PropTypes.shape({
      _id: PropTypes.string,
      assignCertificate: PropTypes.bool,
      certificate: PropTypes.shape({}),
      endDate: PropTypes.instanceOf(Date), // TODO: check type
      name: PropTypes.string,
      pass: PropTypes.number,
      maxQuizTries: PropTypes.number,
      removed: PropTypes.instanceOf(Date),
      userHasAccessToPassTask: PropTypes.bool,
    }).isRequired,
    getResult: PropTypes.func.isRequired,
  };

  static defaultProps = {
    query: {},
    width: '',
  };

  static contextTypes = {
    fetch: PropTypes.func,
    cloudfrontUrl: PropTypes.string,
    organizationSlug: PropTypes.string,
    whitelabeling: PropTypes.shape({}),
  };

  constructor(props, context) {
    super(props);
    const { quizResult, course } = this.props;
    this.menuAnchorEl = null;

    const lessonsAndQuizzes = _((course && course.sections) || [])
      .map('items')
      .flatten()
      .value();

    const quizIndex = _.findIndex(
      lessonsAndQuizzes,
      item => item.item._id === _.get(this, 'props.quiz._id'),
    );

    const nextItem = lessonsAndQuizzes[quizIndex + 1];

    const stateToHtmlOptions = {
      entityStyleFn: entityStyleFn({ cloudfrontUrl: context.cloudfrontUrl }),
    };

    this.state = {
      questionsText: _.map(quizResult.questions, question => {
        const editorState = createEditorState(question.question);
        const editorStateContent =
          editorState && editorState.getCurrentContent();

        return stateToHTML(editorStateContent, stateToHtmlOptions);
      }),
      isReportShow: false,
      isMenuOpen: false,
      allowedAttempts: _.get(this.props, 'quizResult.allowedAttempts'),
      isCertificateIssuing: false,
      nextItem,
      groupActionSubmitting: false,
      groupActionSubmitted: false,
      unlockUser: {},
      isConfirmUnlockDialogShown: false,
      shownAttemptsField: {},
      attemptsField: {},
      isCongratulationsModalOpened: _.has(props, 'query.showCongratulations'),
      isExamResultEditing: false,
    };
    this.state.isReportShow = _.has(props, 'query.report');

    this.isEditor = _.has(this.props, 'query.editor');
    this.restartUrl = this.getRestartUrl();
    this.resultUrl = this.getResultUrl();
    this.reportUrl = this.getReportUrl();
    this.backRoute = this.getBackRoute();
    this.backTooltipTitle = this.getBackTooltipTitle();
    this.mainTitle = this.getMainTitle();
  }

  componentDidMount() {
    if (!isMobileUserAgent()) {
      Intercom.boot(this.props.auth.user, this.context.whitelabeling);
    } else {
      Intercom.hideWidget();
    }
  }

  componentWillReceiveProps(nextProps) {
    if (_.has(nextProps.query, 'report')) {
      this.showReport();
    } else {
      this.setState({
        isReportShow: false,
      });
    }

    if (_.get(this, 'props.quiz._id') !== _.get(nextProps, 'quiz._id')) {
      this.handleMenuClose();

      const lessonsAndQuizzes = _(_.get(nextProps, 'course.sections', []))
        .map('items')
        .flatten()
        .value();

      const quizIndex = _.findIndex(
        lessonsAndQuizzes,
        item => item.item._id === _.get(nextProps, 'quiz._id'),
      );

      const nextItem = lessonsAndQuizzes[quizIndex + 1];

      this.setState({ nextItem });
    }
  }

  getRestartUrl = () => {
    const { task, quiz, course } = this.props;
    if (this.isExam() && task._id) {
      return `/tasks/${task._id}/exams/${quiz._id}?exam&restart`;
    }

    if (!this.isExam() && course._id) {
      return `/courses/${course.slug}/quizzes/${quiz._id}?restart`;
    }

    return undefined;
  };

  getReportUrl = () => {
    const { task, course, quiz, quizResult } = this.props;
    const quizResultId = _.get(quizResult, '_id');

    if (this.isExam() && task._id) {
      return `/tasks/${task._id}/exams/${
        quiz._id
      }/quiz-result?report&exam=true&quizResultId=${quizResultId || ''}`;
    }

    if (!this.isExam() && course._id) {
      return `/courses/${course.slug}/quizzes/${
        quiz._id
      }/quiz-result?report&quizResultId=${quizResultId || ''}`;
    }

    return `/quizzes/${
      quiz._id
    }/quiz-result?report&quizResultId=${quizResultId || ''}`;
  };

  getResultUrl = () => {
    const { task, course, quiz, quizResult } = this.props;
    const quizResultId = _.get(quizResult, '_id');

    if (this.isExam() && task._id) {
      return `/tasks/${task._id}/exams/${
        quiz._id
      }/quiz-result?exam=true&quizResultId=${quizResultId || ''}`;
    }

    if (!this.isExam() && course._id) {
      return `/courses/${course.slug}/quizzes/${
        quiz._id
      }/quiz-result?quizResultId=${quizResultId || ''}`;
    }

    return `/quizzes/${quiz._id}/quiz-result?quizResultId=${quizResultId}`;
  };

  getBackTooltipTitle = () => {
    const {
      intl: { formatMessage },
      course,
    } = this.props;

    if (this.isExam() && !this.isEditor) {
      return formatMessage(messages.tasksLabel);
    }

    if (this.isEditor) {
      return formatMessage(messages.taskResultsLabel);
    }

    if (course._id) {
      return course.name;
    }

    return '';
  };

  getBackRoute = () => {
    const { auth, course, task } = this.props;

    if (this.isExam() && !isTeacher(auth)) {
      return `/tasks`;
    }

    if (this.isExam() && isTeacher(auth) && !task.removed) {
      return `/group-tasks/${task._id}/results`;
    }

    if (course._id) {
      return `/courses/${course.slug}`;
    }

    return `/statistics/quizzes`;
  };

  getMainTitle = () => {
    const {
      quiz,
      intl: { formatMessage },
    } = this.props;
    if (this.isExam() && !this.isEditor) {
      return `${formatMessage(messages.examLabel)} ${quiz.name}`;
    }
    if (this.isExam() && this.isEditor) {
      return `${formatMessage(messages.examLabel)} ${quiz.name} ${formatMessage(
        messages.resultsLabel,
      )}`;
    }
    return quiz.name;
  };

  isExam = () => _.has(this.props, 'task._id');

  issueCertificate = () => {
    const { quizResult, getTaskWithCertificate } = this.props;

    this.setState({
      isCertificateIssuing: true,
    });

    return this.context
      .fetch(
        `/api/quizzes/${quizResult.quizId}/quiz-result/attempts/${quizResult._id}/issue-certificate`,
        {
          method: 'POST',
        },
      )
      .then(res => {
        if (res.ok) {
          getTaskWithCertificate(quizResult.taskId, {
            quizResultId: quizResult._id,
          });
        }

        this.setState({
          isCertificateIssuing: false,
        });
      })
      .catch(err => {
        console.error(err);
        this.setState({
          isCertificateIssuing: false,
        });
      });
  };

  alterToMaxScoreAndAssignCertificate = () => {
    const { quizResult, getTaskWithCertificate } = this.props;

    this.setState({
      isExamResultEditing: true,
    });

    return this.context
      .fetch(
        `/api/quizzes/${quizResult.quizId}/quiz-result/attempts/${quizResult._id}/assign-certificate-with-max-score`,
        {
          method: 'POST',
        },
      )
      .then(res => {
        if (res.ok) {
          getTaskWithCertificate(quizResult.taskId, {
            quizResultId: quizResult._id,
          });
          this.props.getResult(quizResult.quizId, {
            taskId: quizResult.taskId,
            quizResultId: quizResult._id,
          });
        }

        this.setState({
          isExamResultEditing: false,
        });
      })
      .catch(err => {
        console.error(err);
        this.setState({
          isExamResultEditing: false,
        });
      });
  };

  alterToNotPassedAndRevokeCertificate = () => {
    const { quizResult, getTaskWithCertificate } = this.props;

    this.setState({
      isExamResultEditing: true,
    });

    return this.context
      .fetch(
        `/api/quizzes/${quizResult.quizId}/quiz-result/attempts/${quizResult._id}/alter-to-not-passed`,
        {
          method: 'POST',
        },
      )
      .then(res => {
        if (res.ok) {
          getTaskWithCertificate(quizResult.taskId, {
            quizResultId: quizResult._id,
          });
          this.props.getResult(quizResult.quizId, {
            taskId: quizResult.taskId,
            quizResultId: quizResult._id,
          });
        }

        this.setState({
          isExamResultEditing: false,
        });
      })
      .catch(err => {
        console.error(err);
        this.setState({
          isExamResultEditing: false,
        });
      });
  };

  showReport = () => {
    this.setState({
      isReportShow: true,
    });
  };

  handleMenuOpen = () => {
    this.setState({ isMenuOpen: true });
  };

  handleMenuClose = () => {
    this.setState({ isMenuOpen: false });
  };

  showNextItemBtn = (currentQuiz, nextUrl, courseCertificate) => {
    const { nextItem } = this.state;

    if (!nextItem) {
      return null;
    }

    const {
      course,
      intl: { formatMessage },
    } = this.props;

    return nextItem &&
      currentQuiz &&
      currentQuiz.isCompleted &&
      !courseCertificate ? (
      <Tooltip
        title={formatMessage(messages.nextBtnTooltip, {
          name: nextItem.item.name,
        })}
      >
        <Button
          variant="contained"
          color="primary"
          to={`/courses/${course.slug}/${nextUrl}`}
          size="large"
          component={Link}
          className={s.marginTop}
        >
          <FormattedMessage {...messages.nextBtnLabel} />
          <NextIcon />
        </Button>
      </Tooltip>
    ) : null;
  };

  toggleAttemptsField = (_id, value) => {
    const { shownAttemptsField } = this.state;
    shownAttemptsField[_id] = value;
    this.setState(
      {
        shownAttemptsField,
      },
      () => {
        if (value) {
          const el = document.querySelector(`#unlock-exam-btn-${_id}`);
          if (el) el.focus();
        }
      },
    );
  };

  changeAttemptsField = _id => ({ target: { value } }) => {
    const { attemptsField } = this.state;
    const parsedValue = Number.parseInt(value, 10);
    attemptsField[_id] =
      parsedValue >= 1 && parsedValue <= 10 ? parsedValue : '';
    this.setState({
      attemptsField,
    });
  };

  toggleUnlockDialog = (n, value) => {
    this.setState({
      isConfirmUnlockDialogShown: value,
      unlockUser: _.get(n, 'userId', {}),
      unlockReport: _.get(n, '_id'),
    });
  };

  unlockExam = () => {
    const { fetch } = this.context;
    const {
      quizResult: { taskId, _id, quizId },
    } = this.props;
    const { unlockUser, attemptsField, unlockReport } = this.state;
    this.setState({
      groupActionSubmitting: true,
    });

    const params = {
      userId: unlockUser._id,
      taskId,
      attempts: attemptsField[unlockReport] || 1,
    };
    const query = buildQuery(params);

    return fetch(`/api/tasks/unlock-exam?${query}`, { method: 'POST' })
      .then(res => {
        if (!res.ok) {
          this.setState({
            groupActionSubmitting: false,
            groupActionSubmitted: true,
          });
          throw new Error(res.statusText);
        }
      })
      .then(() => {
        this.setState({
          groupActionSubmitting: false,
        });
        this.props.getResult(quizId, { taskId, quizResultId: _id });
        this.toggleUnlockDialog(null, false);
        this.toggleAttemptsField(unlockReport, false);
      })
      .catch(err => {
        console.error(err);
      });
  };

  closeCongratulationsModal = () => {
    this.setState({
      isCongratulationsModalOpened: false,
    });
  };

  render() {
    const {
      auth,
      loadingQuizResult,
      quizResult,
      quiz,
      width,
      course,
      task,
      intl: { formatMessage },
      lang,
    } = this.props;

    const {
      isReportShow,
      questionsText,
      isMenuOpen,
      nextItem,
      allowedAttempts,
      isCertificateIssuing,
      isConfirmUnlockDialogShown,
      groupActionSubmitting,
      groupActionSubmitted,
      unlockUser,
      attemptsField,
      unlockReport,
      shownAttemptsField,
      isCongratulationsModalOpened,
      isExamResultEditing,
    } = this.state;
    const { organizationSlug } = this.context;
    let currentQuiz = null;

    _.each(course.sections, section => {
      _.each(section.items, item => {
        if (item.itemType === 'Quiz' && item.item._id === quiz._id) {
          currentQuiz = item;
        }
      });
    });

    const nextUrl =
      nextItem &&
      (nextItem.itemType === 'Lesson'
        ? `lessons/${nextItem.item.slug}`
        : `quizzes/${nextItem.item._id}`);

    const correctAnswers = _.filter(_.get(quizResult, 'answers'), 'isCorrect');
    let correctedAnswers;
    if (correctAnswers) {
      correctedAnswers = formatMessage(messages.correctedAnswersText, {
        correctNum: correctAnswers.length,
        totalNum: quiz.questions,
      });
    }

    const userTotalPoints = _.round(quizResult.totalPoints, 2) || 0;
    const quizPoints = quizResult.quizPoints || 0;
    const pass = quizResult.pass || 0;
    const reachedPoints = formatMessage(messages.reachedPointsText, {
      userTotalPoints,
      quizPoints,
      pass,
    });
    const timeSpent =
      quizResult.timeSpent !== undefined &&
      moment.utc(quizResult.timeSpent * 1000).format('HH:mm:ss');
    const quizDate = moment(quizResult.timeStart).format('YYYY/MM/DD, HH:mm');
    const totalPoints = `${_.round(quizResult.totalPoints, 2)}/${
      quizResult.quizPoints
    } (${quizResult.pass}%)`;
    const isPass = quizResult.isQuizCompleted ? s.userPassed : s.userFailed;
    const isStudentPass = quizResult.isQuizCompleted
      ? formatMessage(messages.studentPassedText)
      : formatMessage(messages.studentDidNotPassText);

    const maxAttempts = allowedAttempts || task.maxQuizTries + 1;

    const getIcon = (isChecked, answer, isAnswerCorrect) => {
      if (isChecked && answer && answer.isCorrect) {
        return (
          <SkholeStudentCorrect color="#2CCAC7" className={s.userCorrect} />
        );
      }
      if (isChecked && answer && !answer.isCorrect) {
        return (
          <SkholeStudentIncorrect
            color={this.context.whitelabeling.secondaryColor}
            className={s.userIncorrect}
          />
        );
      }
      if (!isChecked && answer && !answer.isCorrect) {
        return <SkholeIcon38 className={s.quizIncorrect} />;
      }
      if (!isChecked && isAnswerCorrect === false) {
        return <SkholeIcon38 className={s.quizIncorrect} />;
      }
      return <SkholeIconIncorrect className={s.userEmpty} />;
    };

    const status = (() => {
      const { examResult } = quizResult;

      if (!quizResult.taskId || !examResult) {
        return null;
      }

      const isEnded =
        !examResult.timeEnd || moment().diff(examResult.timeEnd, 'seconds') > 0;
      const examNotStarted =
        moment().diff(task.endDate, 'seconds') > 0 && !examResult._id;
      const examIsFinished =
        moment().diff(task.endDate, 'seconds') > 0 ||
        (_.get(examResult, 'isQuizCompleted') && isEnded);
      const showUnlockBtn =
        examResult &&
        _.get(examResult, 'allowedAttempts') &&
        _.get(examResult, 'attempts') >= _.get(examResult, 'allowedAttempts') &&
        !_.get(examResult, 'isQuizCompleted') &&
        isEnded;
      const examIsOpen =
        (_.get(examResult, 'allowedAttempts') &&
          examResult._id &&
          _.get(examResult, 'attempts') <
            _.get(examResult, 'allowedAttempts')) ||
        !examResult._id ||
        !isEnded ||
        !_.get(examResult, 'allowedAttempts');

      if (examNotStarted) {
        return <FormattedMessage {...messages.notStartedLabel} />;
      }

      if (examIsFinished) {
        return <FormattedMessage {...messages.finished} />;
      }

      if (showUnlockBtn) {
        return (
          <div id={`unlock-exam-btn-${quizResult._id}`}>
            <Button
              data-test-id="_XG_L2qK6HhwjCeIao_dc"
              // id="unlock-exam-btn"
              variant="contained"
              onClick={() => this.toggleAttemptsField(quizResult._id, true)}
              className={
                shownAttemptsField[quizResult._id] ? s.hidden : s.shown
              }
            >
              <FormattedMessage {...messages.unlockExamLabel} />
            </Button>
            <div className={s.attemptsForm}>
              <TextField
                label={formatMessage(messages.attemptsNumber)} // todo translate
                onChange={this.changeAttemptsField(quizResult._id)}
                value={
                  _.isUndefined(attemptsField[quizResult._id])
                    ? 1
                    : attemptsField[quizResult._id]
                }
                className={
                  !shownAttemptsField[quizResult._id] ? s.hidden : s.shown
                }
                fullWidth
                InputProps={{
                  endAdornment: [
                    <IconButton
                      data-test-id="SBO19vd9VEA9mGsvNyj08"
                      onClick={() =>
                        this.toggleAttemptsField(quizResult._id, false)
                      }
                    >
                      <CloseIcon />
                    </IconButton>,
                    <IconButton
                      data-test-id="hyH0nd7Dgjg5urAM8voVx"
                      color="primary"
                      onClick={() => this.toggleUnlockDialog(quizResult, true)}
                      disabled={
                        !_.isUndefined(attemptsField[quizResult._id]) &&
                        !(
                          Number.parseInt(attemptsField[quizResult._id], 10) >=
                            1 &&
                          Number.parseInt(attemptsField[quizResult._id], 10) <=
                            10
                        )
                      }
                    >
                      <DoneIcon />
                    </IconButton>,
                  ],
                }}
                InputLabelProps={{
                  shrink: true,
                }}
                inputProps={{
                  type: 'number',
                  min: 1,
                  max: 10,
                  size: 2,
                }}
              />
            </div>
          </div>
        );
      }

      if (examIsOpen) {
        return <FormattedMessage {...messages.availableLabel} />;
      }

      return null;
    })();

    return (
      <div className={s.root}>
        <LoadingBar className={s.loadingBar} />
        <div className={s.appFrame}>
          <NavBar
            disableGutters={!isMenuOpen}
            backTooltipTitle={formatMessage(messages.backToTitle, {
              name: this.backTooltipTitle,
            })}
            backIconRoute={this.backRoute}
            mainTitle={this.mainTitle}
            menuProps={{
              isVisible: !this.isExam() && course._id,
              onClick: isMenuOpen ? this.handleMenuClose : this.handleMenuOpen,
              buttonRef: node => {
                this.menuAnchorEl = node;
              },
            }}
          />
          {loadingQuizResult && (
            <div className={s.loadingWrapper}>
              <CircularProgress size={100} thickness={4} />
            </div>
          )}
          <div className={s.content}>
            {!isReportShow && (
              <div className={s.resultContainer} id="result-container">
                <div>
                  <h3>
                    <FormattedMessage {...messages.resultsTitle} />
                  </h3>
                  <span>{correctedAnswers}</span>
                  <br />
                  <span>
                    <FormattedMessage {...messages.userTimeTitle} />
                    {timeSpent}
                  </span>
                  <h4>{reachedPoints}</h4>
                </div>
                <div className={s.buttonsBlock}>
                  {quiz.showRestartBtn &&
                    ((this.isExam() &&
                      task.userHasAccessToPassTask &&
                      ((maxAttempts && quizResult.attempts < maxAttempts) ||
                        !maxAttempts)) ||
                      (!this.isExam() && this.restartUrl)) && (
                      <Button
                        id="quiz-result-restart-btn"
                        variant="contained"
                        color="primary"
                        size="large"
                        className={classNames({
                          [s.button]: true,
                          [s.marginTop]: true,
                        })}
                        component={Link}
                        to={this.restartUrl}
                      >
                        {this.isExam() ? (
                          <div>
                            <FormattedMessage
                              {...messages.restartExamBtnLabel}
                            />
                            &nbsp;
                            {!!task.maxQuizTries &&
                              `${quizResult.attempts}/${maxAttempts}`}
                          </div>
                        ) : (
                          <FormattedMessage {...messages.restartQuizBtnLabel} />
                        )}
                      </Button>
                    )}
                  {(quiz.showReport || isTeacher(auth)) && (
                    <Button
                      variant="contained"
                      size="large"
                      color="primary"
                      className={classNames({
                        [s.button]: true,
                        [s.marginTop]: true,
                      })}
                      component={Link}
                      to={this.reportUrl}
                    >
                      {this.isExam() ? (
                        <FormattedMessage
                          {...messages.viewExamReportBtnLabel}
                        />
                      ) : (
                        <FormattedMessage
                          {...messages.viewQuizReportBtnLabel}
                        />
                      )}
                    </Button>
                  )}
                  {!this.isExam() &&
                    this.showNextItemBtn(
                      currentQuiz,
                      nextUrl,
                      course.certificate,
                    )}
                  {this.isExam() && (
                    <Button
                      variant="outlined"
                      color="primary"
                      href={`/${lang}${
                        organizationSlug ? `/${organizationSlug}` : ''
                      }/tasks`}
                      component="a"
                      size="large"
                      className={classNames({
                        [s.button]: true,
                        [s.marginTop]: true,
                      })}
                    >
                      <FormattedMessage {...messages.backToTasks} />
                    </Button>
                  )}
                  {!this.isExam() && course.certificate && (
                    <Button
                      variant="contained"
                      color="primary"
                      href={`/${lang}${
                        organizationSlug ? `/${organizationSlug}` : ''
                      }/cert/${course.certificate.code}`}
                      component="a"
                      target={isWidthUp('sm', width) ? '_blank' : '_self'}
                      size="large"
                      className={classNames(s.button, s.marginTop)}
                    >
                      <FormattedMessage {...messages.showCertificateBtnLabel} />
                    </Button>
                  )}
                  {this.isExam() &&
                    task.certificate &&
                    (quiz.isSkholeCertified || task.assignCertificate) &&
                    quizResult.isQuizCompleted === true && (
                      <Button
                        variant="contained"
                        color="primary"
                        href={`/${lang}${
                          organizationSlug ? `/${organizationSlug}` : ''
                        }/cert/${_.get(task, 'certificate.code')}`}
                        component="a"
                        target={isWidthUp('sm', width) ? '_blank' : '_self'}
                        size="large"
                        className={classNames(s.button, s.marginTop)}
                      >
                        <FormattedMessage
                          {...messages.showExamCertificateBtnLabel}
                        />
                      </Button>
                    )}
                </div>
              </div>
            )}
            {isReportShow && (
              <div className={s.reportContainer}>
                <div>
                  <div className={s.nameWrapper}>
                    <div className={s.topBlock}>
                      {!this.isEditor && (
                        <Button
                          variant="contained"
                          size="large"
                          color="primary"
                          className={classNames({
                            [s.button]: true,
                          })}
                          component={Link}
                          to={this.resultUrl}
                        >
                          <FormattedMessage {...messages.goToResultBtnLabel} />
                        </Button>
                      )}
                    </div>
                  </div>
                  <div className={s.dateBlock}>
                    <span className={s.userName}>
                      {_.get(quizResult, 'userId.lastName')} &nbsp;
                      {_.get(quizResult, 'userId.firstName')}
                    </span>
                    <span className={s.dateTimeWrapper}>
                      <span className={s.dateTime}>
                        <FormattedMessage {...messages.dateLabel} />
                        &nbsp;
                        {quizDate}
                      </span>
                      <span className={s.dateTime}>
                        {this.isExam() ? (
                          <FormattedMessage {...messages.examTimeLabel} />
                        ) : (
                          <FormattedMessage {...messages.quizTimeLabel} />
                        )}
                        &nbsp;
                        {timeSpent}
                      </span>
                    </span>
                  </div>
                  <div className={s.generalQuizInfo}>
                    {task && task._id && (
                      <div className={s.examNameRow}>
                        <span className={s.generalInfoItem}>
                          <FormattedMessage {...messages.examLabel} />
                        </span>
                        <span className={s.examName}>{task.name}</span>
                      </div>
                    )}
                    <div className={s.points}>
                      <span className={s.generalInfoItem}>
                        <FormattedMessage {...messages.pointsInTotalLabel} />
                      </span>
                      <span className={isPass}>{totalPoints}</span>
                    </div>
                    <div className={s.requirement}>
                      <span className={s.generalInfoItem}>
                        <FormattedMessage
                          {...messages.passRequirermentLabel}
                          values={{
                            perc:
                              task.pass !== undefined ? task.pass : quiz.pass,
                          }}
                        />
                      </span>
                      <span className={isPass}>{isStudentPass}</span>
                    </div>
                    <div className={s.attempts}>
                      <span className={s.generalInfoItem}>
                        <FormattedMessage {...messages.numberOfAttemptsLabel} />
                      </span>
                      <span className={s.attemptsCount}>
                        {quizResult.attempts}
                      </span>
                    </div>
                    {quizResult.taskId && isTeacher(auth) ? (
                      <div className={s.status}>
                        <span className={s.generalInfoItem}>
                          <FormattedMessage {...messages.statusLabel} />
                        </span>
                        <span className={s.statusInfo}>{status}</span>
                      </div>
                    ) : null}
                    {/* <div className={s.quizProgress}>
                      <span className={s.generalInfoItem}>
                        <FormattedMessage {...messages.progressLabel} />
                      </span>
                      <div className={s.userProgress}>
                        <span className={s.me}>
                          <FormattedMessage {...messages.meLabel} />
                        </span>
                        <LinearProgress
                          variant="determinate"
                          value={quizResult.pass}
                          classes={{
                            root: s.progressBar,
                            colorPrimary: s.colorPrimary,
                            barColorPrimary: s.primaryColor,
                          }}
                        />
                      </div>
                      <div className={s.userProgress}>
                        <span className={s.me}>
                          <FormattedMessage {...messages.myGroupLabel} />
                        </span>
                        <LinearProgress
                          variant="determinate"
                          value={quizResult.groupResult}
                          classes={{
                            root: s.progressBar,
                            colorPrimary: s.colorPrimary,
                            barColorPrimary: s.groupColorBar,
                          }}
                        />
                      </div>
                    </div> */}
                  </div>
                  <div className={s.divider} />
                  {quizResult.taskId && !quizResult.isEnded && (
                    <div className={s.questionsContainer}>
                      <span className={s.userName}>
                        <FormattedMessage
                          {...messages.quizSessionIsNotEnded}
                          values={{
                            timeEnd: moment(quizResult.timeEnd).format(
                              'YYYY-MM-DD HH:mm',
                            ),
                          }}
                        />
                      </span>
                    </div>
                  )}
                  {(quizResult.isEnded || !quizResult.taskId) && (
                    <div className={s.questionsContainer}>
                      <span className={s.userName}>
                        <FormattedMessage {...messages.questionsLabel} />
                        <div
                          className={classNames(
                            s.rightPart,
                            s.displayOnlyMobile,
                          )}
                        >
                          <span className={s.correctOrStudent}>
                            <FormattedMessage {...messages.correctLabel} />
                          </span>
                          <span className={s.correctOrStudent}>
                            <FormattedMessage {...messages.studentLabel} />
                          </span>
                        </div>
                      </span>
                      <div className={s.questionsItems}>
                        {_.map(quizResult.questions, (question, index) => {
                          let questionHtml = questionsText[index];
                          const key = index;
                          const zeroPointsQuestion = question.points === 0;
                          const currentQuestion = _.find(
                            quizResult.answers,
                            item =>
                              item.question === question._id &&
                              item.values !== undefined,
                          );
                          let questionPoints;
                          let questionAnswers;
                          let questionAnswersWithoutTranslation;

                          const substitutedFormulaMathQuestion = _.find(
                            quizResult.substitutedFormulaMathQuestions,
                            substitutedFormulaObj =>
                              substitutedFormulaObj.questionId.toString() ===
                              question._id.toString(),
                          );
                          let mathQuestionAllowedDecimalsHint = '';
                          if (question.type === 'basic math') {
                            questionHtml = substituteVariablesInQuestion(
                              questionHtml,
                              _.get(
                                substitutedFormulaMathQuestion,
                                'generatedVariables',
                              ),
                            );
                            const allowedDecimals = _.get(
                              question,
                              'allowedDecimals',
                            );
                            if (allowedDecimals === 'not allowed') {
                              mathQuestionAllowedDecimalsHint = (
                                <FormattedMessage
                                  {...messages.mathQuestionNotAllowedDecimalsHint}
                                />
                              );
                            } else if (allowedDecimals !== 'no preference') {
                              mathQuestionAllowedDecimalsHint = (
                                <FormattedMessage
                                  {...messages.mathQuestionAllowedDecimalsHint}
                                  values={{
                                    allowedDecimals: parseInt(
                                      allowedDecimals,
                                      10,
                                    ),
                                  }}
                                />
                              );
                            }
                          }

                          if (question.allowDifferentPoints) {
                            questionPoints = _.sum(
                              _.map(
                                question.generalAnswers,
                                answer => answer.points,
                              ),
                            );
                          } else if (!question.allowDifferentPoints) {
                            questionPoints = question.points;
                            if (question.type === 'multiple choice') {
                              questionPoints =
                                question.points *
                                _.filter(question.generalAnswers, 'isCorrect')
                                  .length;
                            }
                          }
                          if (question.type === 'true or false') {
                            const trueValue = formatMessage(messages.trueValue);
                            const falseValue = formatMessage(
                              messages.falseValue,
                            );
                            questionAnswers = [trueValue, falseValue];
                            questionAnswersWithoutTranslation = [
                              'true',
                              'false',
                            ];
                          }
                          return (
                            <div className={s.questionResult} key={key}>
                              <div className={s.questionItem}>
                                <Interweave
                                  tagName="div"
                                  className={s.questionReport}
                                  content={questionHtml}
                                />
                                <div className={s.rightPart}>
                                  {question.type !== 'fill in blank' &&
                                    question.type !== 'basic math' &&
                                    !zeroPointsQuestion && (
                                      <span className={s.correctOrStudent}>
                                        <FormattedMessage
                                          {...messages.correctLabel}
                                        />
                                      </span>
                                    )}
                                  <span className={s.correctOrStudent}>
                                    <FormattedMessage
                                      {...messages.studentLabel}
                                    />
                                  </span>
                                </div>
                              </div>
                              {question.type === 'basic math' &&
                                _.get(
                                  substitutedFormulaMathQuestion,
                                  'substitutedFormula',
                                ) && (
                                  <div
                                    className={classNames(
                                      s.questionReport,
                                      s.mathAllowedDecimalsHint,
                                    )}
                                  >
                                    {mathQuestionAllowedDecimalsHint}
                                  </div>
                                )}
                              <div>
                                {question.type === 'fill in blank' &&
                                  (() => {
                                    let wasRightAnswer = true;
                                    const isCorrect =
                                      (currentQuestion &&
                                        _.map(
                                          question.fillInBlankAnswers,
                                          item => item.toLowerCase(),
                                        ).includes(
                                          currentQuestion.values.toLowerCase(),
                                        )) ||
                                      !question.points;

                                    const count = _.sumBy(
                                      question.fillInBlankAnswers,
                                      answerItem => {
                                        const isCorrectAnswer = currentQuestion
                                          ? answerItem ===
                                            currentQuestion.values
                                          : false;
                                        return isCorrectAnswer ? 1 : 0;
                                      },
                                    );
                                    if (count === 0 && question.points) {
                                      wasRightAnswer = false;
                                    }

                                    return (
                                      <div>
                                        <div className={s.answerBlock}>
                                          <div
                                            className={classNames(
                                              s.reportAnswer,
                                              s.reportAnswerFillInBlank,
                                            )}
                                          >
                                            <div>
                                              {formatMessage(
                                                messages.studentLabel,
                                              )}
                                              :{' '}
                                              <span
                                                style={{
                                                  color:
                                                    wasRightAnswer && isCorrect
                                                      ? 'green'
                                                      : 'red',
                                                }}
                                              >
                                                {currentQuestion &&
                                                  currentQuestion.values}
                                              </span>
                                            </div>
                                            {!zeroPointsQuestion && (
                                              <div>
                                                {formatMessage(
                                                  messages.correctLabel,
                                                )}
                                                :{' '}
                                                {question.fillInBlankAnswers.join(
                                                  ', ',
                                                )}
                                              </div>
                                            )}
                                          </div>
                                          <div className={s.isCorrect}>
                                            {wasRightAnswer && isCorrect ? (
                                              <SkholeStudentCorrect
                                                color="#2CCAC7"
                                                className={s.userCorrect}
                                              />
                                            ) : (
                                              <SkholeIconIncorrect
                                                className={s.userEmpty}
                                              />
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    );
                                  })()}
                                {question.type === 'basic math' &&
                                  (() => {
                                    const isCorrect =
                                      currentQuestion &&
                                      currentQuestion.isCorrect;
                                    return (
                                      <div>
                                        <div className={s.answerBlock}>
                                          <div
                                            className={classNames(
                                              s.reportAnswer,
                                              s.reportAnswerFillInBlank,
                                            )}
                                          >
                                            <div>
                                              {formatMessage(
                                                messages.studentLabel,
                                              )}
                                              :{' '}
                                              <span
                                                style={{
                                                  color: isCorrect
                                                    ? 'green'
                                                    : 'red',
                                                }}
                                              >
                                                {currentQuestion &&
                                                  replaceDecimalsSeparatorToComma(
                                                    currentQuestion.values,
                                                  )}
                                              </span>
                                            </div>
                                            {!zeroPointsQuestion && (
                                              <div>
                                                {formatMessage(
                                                  messages.correctLabel,
                                                )}
                                                :{' '}
                                                {replaceDecimalsSeparatorToComma(
                                                  _.get(
                                                    substitutedFormulaMathQuestion,
                                                    'correctAnswer',
                                                  ),
                                                )}
                                              </div>
                                            )}
                                          </div>
                                          <div className={s.isCorrect}>
                                            {isCorrect ? (
                                              <SkholeStudentCorrect
                                                color="#2CCAC7"
                                                className={s.userCorrect}
                                              />
                                            ) : (
                                              <SkholeIconIncorrect
                                                className={s.userEmpty}
                                              />
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    );
                                  })()}
                                {question.type !== 'fill in blank' &&
                                  question.type !== 'basic math' &&
                                  question.generalAnswers.map((answer, i) => {
                                    const answerKey = i;
                                    let isChecked;

                                    if (
                                      question.type === 'single choice' &&
                                      currentQuestion
                                    ) {
                                      isChecked =
                                        currentQuestion.values ===
                                        answer.description;
                                    } else if (
                                      question.type === 'multiple choice'
                                    ) {
                                      isChecked = currentQuestion
                                        ? _.includes(
                                            currentQuestion.values,
                                            answer.description,
                                          )
                                        : false;
                                    }
                                    return (
                                      <div key={answerKey}>
                                        {(question.type === 'single choice' ||
                                          question.type ===
                                            'multiple choice') && (
                                          <div className={s.answerBlock}>
                                            <span className={s.reportAnswer}>
                                              {answer.description}
                                            </span>
                                            <div className={s.rightPart}>
                                              {answer.isCorrect &&
                                                !zeroPointsQuestion && (
                                                  <SkholeIcon38Correct
                                                    className={s.quizCorrect}
                                                  />
                                                )}
                                              {!answer.isCorrect &&
                                                !zeroPointsQuestion && (
                                                  <SkholeIcon38
                                                    className={s.quizIncorrect}
                                                  />
                                                )}
                                              {zeroPointsQuestion &&
                                              isChecked ? (
                                                <SkholeStudentCorrect
                                                  color="#2CCAC7"
                                                  className={s.userCorrect}
                                                />
                                              ) : (
                                                getIcon(isChecked, answer)
                                              )}
                                            </div>
                                          </div>
                                        )}
                                      </div>
                                    );
                                  })}
                                {question.type === 'true or false' &&
                                  questionAnswers.map((answer, ind) => {
                                    const itemKey = ind;
                                    const currentQuestionAnswer =
                                      questionAnswersWithoutTranslation[ind];
                                    const isChecked =
                                      currentQuestion &&
                                      currentQuestion.values ===
                                        currentQuestionAnswer.toLowerCase();

                                    const isAnswerCorrect =
                                      currentQuestionAnswer.toLowerCase() ===
                                      question.trueOrFalseAnswers;
                                    return (
                                      <div key={itemKey}>
                                        <div className={s.answerBlock}>
                                          <span className={s.reportAnswer}>
                                            {answer}
                                          </span>
                                          <div className={s.rightPart}>
                                            {isAnswerCorrect &&
                                              !zeroPointsQuestion && (
                                                <SkholeIcon38Correct
                                                  className={s.quizCorrect}
                                                />
                                              )}
                                            {!isAnswerCorrect &&
                                              !zeroPointsQuestion && (
                                                <SkholeIcon38
                                                  className={s.quizIncorrect}
                                                />
                                              )}
                                            {zeroPointsQuestion && isChecked ? (
                                              <SkholeStudentCorrect
                                                color="#2CCAC7"
                                                className={s.userCorrect}
                                              />
                                            ) : (
                                              getIcon(
                                                isChecked,
                                                currentQuestion,
                                                isAnswerCorrect,
                                              )
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    );
                                  })}
                                {question.type === 'reflection exercise' &&
                                  (() => (
                                    <div>
                                      <div className={s.answerBlock}>
                                        <div
                                          className={classNames(
                                            s.reportAnswer,
                                            s.reportAnswerFillInBlank,
                                          )}
                                        >
                                          <div>
                                            {formatMessage(
                                              messages.studentLabel,
                                            )}
                                            :{' '}
                                            <div
                                              style={{
                                                color: 'green',
                                              }}
                                            >
                                              <Interweave
                                                content={convertBreakLines(
                                                  currentQuestion?.values,
                                                )}
                                              />
                                            </div>
                                          </div>
                                          {!!question.reflectionNote && (
                                            <div
                                              className={
                                                s.reflectionNoteContainer
                                              }
                                            >
                                              {formatMessage(
                                                messages.reflectionNoteLabel,
                                              )}
                                              <Interweave
                                                tagName="div"
                                                className={s.reflectionNote}
                                                content={convertBreakLines(
                                                  question.reflectionNote,
                                                )}
                                              />
                                            </div>
                                          )}
                                        </div>
                                        <div className={s.rightPart}>
                                          <SkholeStudentCorrect
                                            color="#2CCAC7"
                                            className={s.userCorrect}
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  ))()}
                              </div>
                              {!zeroPointsQuestion && (
                                <div>
                                  <span className={s.questionPoints}>
                                    <FormattedMessage
                                      {...messages.pointsLabel}
                                    />{' '}
                                    {currentQuestion
                                      ? _.round(currentQuestion.points, 2)
                                      : 0}
                                    /{questionPoints}
                                  </span>
                                </div>
                              )}
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  )}
                </div>
                {!this.isEditor && (
                  <div className={s.buttonsBlock}>
                    <div className={s.divider} />
                    {((this.isExam() &&
                      task.userHasAccessToPassTask &&
                      ((maxAttempts && quizResult.attempts < maxAttempts) ||
                        !maxAttempts)) ||
                      !this.isExam()) &&
                      this.restartUrl &&
                      quiz.showRestartBtn && (
                        <Button
                          variant="contained"
                          size="large"
                          color="primary"
                          className={classNames({
                            [s.button]: true,
                            [s.marginTop]: true,
                          })}
                          component={Link}
                          to={this.restartUrl}
                        >
                          {this.isExam() ? (
                            <div>
                              <FormattedMessage
                                {...messages.restartExamBtnLabel}
                              />
                              &nbsp;
                              {maxAttempts &&
                                `${quizResult.attempts}/${maxAttempts}`}
                            </div>
                          ) : (
                            <FormattedMessage
                              {...messages.restartQuizBtnLabel}
                            />
                          )}
                        </Button>
                      )}
                    <Button
                      variant="contained"
                      size="large"
                      color="primary"
                      className={classNames({
                        [s.button]: true,
                        [s.marginTop]: true,
                      })}
                      component={Link}
                      to={this.resultUrl}
                    >
                      <FormattedMessage {...messages.goToResultBtnLabel} />
                    </Button>
                    {!this.isExam() &&
                      this.showNextItemBtn(
                        currentQuiz,
                        nextUrl,
                        course.certificate,
                      )}
                    {this.isExam() && (
                      <Button
                        variant="outlined"
                        color="primary"
                        href={`/${lang}${
                          organizationSlug ? `/${organizationSlug}` : ''
                        }/tasks`}
                        component="a"
                        size="large"
                        className={classNames({
                          [s.button]: true,
                          [s.marginTop]: true,
                        })}
                      >
                        <FormattedMessage {...messages.backToTasks} />
                      </Button>
                    )}
                    {!this.isExam() && course.certificate && (
                      <Button
                        variant="contained"
                        color="primary"
                        href={`/${lang}${
                          organizationSlug ? `/${organizationSlug}` : ''
                        }/cert/${course.certificate.code}`}
                        component="a"
                        target={isWidthUp('sm', width) ? '_blank' : '_self'}
                        size="large"
                        className={classNames({
                          [s.button]: true,
                          [s.marginTop]: true,
                        })}
                      >
                        <FormattedMessage
                          {...messages.showCertificateBtnLabel}
                        />
                      </Button>
                    )}
                    {this.isExam() &&
                      task.certificate &&
                      (quiz.isSkholeCertified || task.assignCertificate) &&
                      quizResult.isQuizCompleted === true && (
                        <Button
                          variant="contained"
                          color="primary"
                          href={`/${lang}${
                            organizationSlug ? `/${organizationSlug}` : ''
                          }/cert/${_.get(task, 'certificate.code')}`}
                          component="a"
                          target={isWidthUp('sm', width) ? '_blank' : '_self'}
                          size="large"
                          className={classNames(s.button, s.marginTop)}
                        >
                          <FormattedMessage
                            {...messages.showExamCertificateBtnLabel}
                          />
                        </Button>
                      )}
                    {isAdmin(auth) &&
                      (quiz.isSkholeCertified || task.assignCertificate) &&
                      quizResult.isQuizCompleted === true &&
                      task &&
                      !task.certificate && (
                        <Button
                          data-test-id="i4p4fZ3xo9RC8o50JQgWj"
                          variant="contained"
                          color="primary"
                          size="large"
                          className={classNames(s.button, s.marginTop)}
                          onClick={this.issueCertificate}
                          disabled={isCertificateIssuing || isExamResultEditing}
                        >
                          <FormattedMessage {...messages.issueCertificate} />
                          {isCertificateIssuing && (
                            <CircularProgress
                              size={24}
                              className={s.buttonProgress}
                            />
                          )}
                        </Button>
                      )}
                    {isAdmin(auth) &&
                      (quiz.isSkholeCertified || task.assignCertificate) &&
                      quizResult.isQuizCompleted === false &&
                      task &&
                      !task.certificate && (
                        <Button
                          data-test-id="J351laAPmCs9R5rxVrGis"
                          variant="contained"
                          color="primary"
                          size="large"
                          className={classNames(s.button, s.marginTop)}
                          onClick={this.alterToMaxScoreAndAssignCertificate}
                          disabled={isExamResultEditing}
                        >
                          <FormattedMessage
                            {...messages.alterToMaxScoreAndAssignCertificate}
                          />
                          {isExamResultEditing && (
                            <CircularProgress
                              size={24}
                              className={s.buttonProgress}
                            />
                          )}
                        </Button>
                      )}
                    {isAdmin(auth) &&
                      (quiz.isSkholeCertified || task.assignCertificate) &&
                      quizResult.isQuizCompleted === true &&
                      task &&
                      task.certificate && (
                        <Button
                          data-test-id="IyZ83CN9ZPgUl4N7bPWGH"
                          variant="contained"
                          color="primary"
                          size="large"
                          className={classNames(s.button, s.marginTop)}
                          onClick={this.alterToNotPassedAndRevokeCertificate}
                          disabled={isExamResultEditing}
                        >
                          <FormattedMessage
                            {...messages.alterToNotPassedAndRevokeCertificate}
                          />
                          {isExamResultEditing && (
                            <CircularProgress
                              size={24}
                              className={s.buttonProgress}
                            />
                          )}
                        </Button>
                      )}
                  </div>
                )}
              </div>
            )}
          </div>
          <SectionItemNavigationMenu
            isMenuOpen={isMenuOpen}
            menuAnchorEl={this.menuAnchorEl}
            handleMenuClose={this.handleMenuClose}
            course={course}
            currentItemId={quiz._id}
          />
          <ConfirmUnlockDialog
            isShown={isConfirmUnlockDialogShown}
            attempts={_.get(attemptsField, unlockReport, 1)}
            onClose={() => this.toggleUnlockDialog(null, false)}
            submit={() => this.unlockExam()}
            groupActionSubmitting={groupActionSubmitting}
            groupActionSubmitted={groupActionSubmitted}
            className={s.dialogs}
            user={`${unlockUser.lastName} ${unlockUser.firstName}`}
            exam={task.name}
          />
          {course._id && (
            <Modal
              open={isCongratulationsModalOpened}
              onClose={this.closeCongratulationsModal}
            >
              <CongratulationsModal
                onClose={this.closeCongratulationsModal}
                course={course}
                hideCertificateBtn={
                  hasMedicalLicense(auth.user.mainGroup) ||
                  !course.assignCertificate ||
                  isTrial(auth)
                }
              />
            </Modal>
          )}
        </div>
      </div>
    );
  }
}
